
























































































































































































































































































































































































































import Vue from "vue";
import dayjs from "dayjs";
import http, { handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import eventBus from "@/services/eventBus";
import api from "../services/api";
import {
  TransactionImportError,
  TransactionImportRow,
} from "../models/TransactionImport";
import CheckBox from "@/components/CheckBox.vue";
import LookupComboBox from "@/modules/transactions/components/LookupComboBox.vue";
import { t } from "@/plugins/i18n";

// K2D "Export/Import -> Tranzakció import" (w_popup_tmp_boktrans) portja.
// Puffer-modell (K2D pb_ok / of_Update): a betöltés, szerkesztés, új sor és törlés a KLIENSEN
// gyűlik; a "Mentés" írja ki a teljes puffert a hmboktmptrans-ba (insert/update/delete sync),
// a "Mégse" pedig eldobja és visszatölti az utoljára mentett állapotot. Az Ellenőrzés/Könyvelés
// előtt — ha van nem mentett változás — automatikusan ment (K2D pb_check is pb_ok-ot hív).
// A kijelölés a teljes külső-ID-csoportra vonatkozik (K2D pb_treff '§'), a könyvelés
// jelölt-csoport atomikus: kijelölt sor hibája esetén semmi nem könyvelődik.

interface Lookup {
  id: number;
  name: string;
}

interface Data {
  file: File | null;
  rows: TransactionImportRow[];
  statuses: Lookup[];
  transTypes: Lookup[];
  bookTypes: any[];
  currencies: any[];
  accounts: any[];
  dimensions: any[];
  pos: any[];
  years: any[];
  selectedYear: number;
  status: number;
  transType: number;
  bookType: number;
  uploadErrors: string[];
  bookErrors: TransactionImportError[];
  createdIds: number[];
  clearConfirm: boolean;
  dirty: boolean;
  editingRow: TransactionImportRow | null;
  nextTempId: number;
  totalTemp: number;
  currTotalTemp: number;
  columns: any[];
}

interface Methods {
  formatDate(d: string): string;
  formatNumber(v: number | null): string;
  bookTypeText(bt: any): string;
  loadYears(): Promise<void>;
  loadYearData(): Promise<void>;
  dimCodesFor(type: number): any[];
  onAccountChange(row: TransactionImportRow, selected: any): void;
  onDimCodeChange(row: TransactionImportRow, field: string, selected: any): void;
  onWorkNumberChange(row: TransactionImportRow, selected: any): void;
  reload(): Promise<void>;
  uploadFile(): Promise<void>;
  save(): Promise<boolean>;
  cancelChanges(): Promise<void>;
  addRow(): void;
  onRowClick(event: any): void;
  onDateInput(row: TransactionImportRow, value: string): void;
  markDirty(): void;
  onAmount(row: TransactionImportRow): void;
  rateOf(row: TransactionImportRow): number;
  onTotalChange(row: TransactionImportRow): void;
  onCurrTotalChange(row: TransactionImportRow): void;
  runCheck(): Promise<void>;
  rowErrors(row: TransactionImportRow): string[];
  book(): Promise<void>;
  runBook(checkOnly: boolean): Promise<void>;
  toggleGroup(row: TransactionImportRow): void;
  selectAll(selected: boolean): void;
  askDelete(row: TransactionImportRow): void;
  confirmDelete(row: TransactionImportRow): void;
  cancelDelete(row: TransactionImportRow): void;
  clearAll(): Promise<void>;
  downloadTemplate(): Promise<void>;
  applyErrors(errors: TransactionImportError[]): void;
}

interface Computed {
  selectedCount: number;
  gridRows: TransactionImportRow[];
  totalDisplay: string;
  currTotalDisplay: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: "TransactionImportView",

  components: { CheckBox, LookupComboBox },

  data(): Data {
    return {
      file: null,
      rows: [],
      statuses: [],
      transTypes: [],
      bookTypes: [],
      currencies: [],
      accounts: [],
      dimensions: [],
      pos: [],
      years: [],
      selectedYear: 0,
      status: 3, // K2D dw_status default
      transType: 3,
      bookType: 11, // K2D default napló (MX / "Vegyes könyvelés")
      uploadErrors: [],
      bookErrors: [],
      createdIds: [],
      clearConfirm: false,
      dirty: false,
      editingRow: null,
      nextTempId: -1, // a nem mentett (import/új) sorok egyedi, negatív ideiglenes id-ja
      totalTemp: 0, // a szerkesztett sor HUF összege (formázott inputhoz — TransactionItemEdit minta)
      currTotalTemp: 0, // a szerkesztett sor deviza összege
      columns: [
        // Akció-oszlop: legelöl, fejléc nélkül (törlés + hibajelző) — TF-konvenció (balra).
        { cell: "commandCell", title: "", width: "45px", filterable: false, sortable: false },
        // Innentől a K2D d_g_tmp_boktrans látható oszlopsorrendje (balról jobbra):
        // treff(§) → external_tr_id → acc_date → acc_event → accno_c → acc_sign → total →
        // curr_total → currency → exchange_rate → dimcode1/2/3/5_c → car → worknumber → book_type_c →
        // ext_code → remark → note.
        { cell: "selectCell", title: t("GeneralLedger_Kijelol"), width: "70px", filterable: false, sortable: false, headerClassName: "center_text" },
        { field: "externalTrId", title: t("KulsoID"), width: "130px", cell: "externalTrIdCell" },
        { field: "accDate", title: t("Datum"), width: "150px", cell: "accDateCell" },
        // A szöveges oszlopoknak (esemény / megjegyzés / széljegyzet) EXPLICIT width kell —
        // a fix-width oszlopok összege önmagában is meghaladja egy szokásos 1920px-es nézet
        // rács-szélességét, ezért width nélkül (Kendo "maradék hely") ezek 0px-re esnének össze
        // (ugyanaz a hiba-osztály, mint a Könyvelési sablonok Megjegyzés-oszlopánál — javítva).
        { field: "accEvent", title: t("GazdasagiEsemeny"), width: "220px", cell: "accEventCell" },
        { field: "accNo", title: t("FokonyviSzam"), width: "130px", cell: "accNoCell" },
        { field: "accSign", title: "T/K", width: "80px", cell: "accSignCell" },
        { field: "total", title: t("GeneralLedger_OsszegHUF"), width: "120px", cell: "totalCell", className: "right_text" },
        { field: "currTotal", title: t("DevizaOsszeg"), width: "130px", cell: "currTotalCell", className: "right_text" },
        { field: "currency", title: t("Penznem"), width: "90px", cell: "currencyCell" },
        { field: "exchangeRate", title: t("Arfolyam"), width: "110px", cell: "exchangeRateCell", className: "right_text" },
        { field: "dimCode1", title: t("Dim1"), width: "100px", cell: "dim1Cell" },
        { field: "dimCode2", title: t("GeneralLedger_Dim2"), width: "100px", cell: "dim2Cell" },
        { field: "dimCode3", title: t("GeneralLedger_Dim3"), width: "100px", cell: "dim3Cell" },
        { field: "dimCode11", title: t("GeneralLedger_Dim11"), width: "100px", cell: "dim11Cell" },
        { field: "dimCode9", title: t("GeneralLedger_Dim9"), width: "100px", cell: "dim9Cell" },
        { field: "car", title: t("Gepjarmu"), width: "100px", cell: "carCell" },
        { field: "workNumber", title: t("Munkaszam"), width: "130px", cell: "workNumberCell" },
        { field: "bookTypeCode", title: t("Naplo"), width: "90px", cell: "bookTypeCell" },
        { field: "extCode", title: t("PartnerID"), width: "110px", cell: "extCodeCell" },
        { field: "remark", title: t("Megjegyzes"), width: "180px", cell: "remarkCell" },
        { field: "note", title: t("GeneralLedger_Szeljegyzet"), width: "150px", cell: "noteCell" },
        { width: 0 },
      ],
    };
  },

  computed: {
    selectedCount(): number {
      return this.rows.filter((r) => r.selected).length;
    },
    // A sorok inEdit-jét a kijelölt (editingRow) sor alapján állítja — a grid csak erre renderel újra
    // (a mezők v-modelje nem, így szerkesztés közben nincs fókuszvesztés — TransactionItemEdit minta).
    gridRows(): TransactionImportRow[] {
      return this.rows.map((r) => {
        r.inEdit = r === this.editingRow;
        return r;
      });
    },
    // Formázott (ezres-tagolt) szöveges összeg-inputok a szerkesztett sorhoz (TransactionItemEdit minta):
    // a getter tagolva jelenít meg, a setter a beírt szövegből számot fejt (szóközök törlése, tizedes ',' → '.').
    totalDisplay: {
      get(): string {
        return this.totalTemp
          ? new Intl.NumberFormat("hu-HU", { maximumFractionDigits: 2 }).format(this.totalTemp)
          : "";
      },
      set(val: string) {
        const n = parseFloat(String(val).replace(/\s/g, "").replace(",", "."));
        this.totalTemp = isNaN(n) ? 0 : n;
      },
    },
    currTotalDisplay: {
      get(): string {
        return this.currTotalTemp
          ? new Intl.NumberFormat("hu-HU", { maximumFractionDigits: 2 }).format(this.currTotalTemp)
          : "";
      },
      set(val: string) {
        const n = parseFloat(String(val).replace(/\s/g, "").replace(",", "."));
        this.currTotalTemp = isNaN(n) ? 0 : n;
      },
    },
  },

  async beforeMount() {
    // A státusz/típus lookupok a tranzakció-modul detail endpointjairól jönnek (AuditXML minta).
    const [stats, types, bookTypes, currencies, pos] = await Promise.all([
      http.get<ApiResponse<Lookup[]>>("general-ledger-transaction/detail/trans-stats").then(handleApiResponse),
      http.get<ApiResponse<Lookup[]>>("general-ledger-transaction/detail/trans-types").then(handleApiResponse),
      http.get<ApiResponse<Lookup[]>>("general-ledger-transaction/detail/book-types").then(handleApiResponse),
      // K2D dddw_currency8_os forrása: a csgencurrency ISO-kódjai (a `currency` mező a kód).
      http.get<ApiResponse<any[]>>("currency").then(handleApiResponse),
      // K2D hmgenpurchorder — a munkaszám-lookup listája (év-független).
      http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/pos").then(handleApiResponse),
    ]);
    // K2D dddw_ssboktransstat_1: csak a 2-5 státuszok választhatók.
    this.statuses = stats.filter((s) => s.id >= 2 && s.id <= 5);
    // K2D dddw_transtype: a stagingnél csak a (3,7) tranzakció-típusok választhatók.
    this.transTypes = types.filter((t: Lookup) => t.id === 3 || t.id === 7);
    this.bookTypes = bookTypes;
    this.currencies = currencies;
    this.pos = pos;
    // A fkszám/dimenzió lookup a választott könyvelési évhez kötött (K2D il_Year — BookingTemplateEditor minta).
    await this.loadYears();
    await this.loadYearData();
    await this.reload();
  },

  methods: {
    formatDate(d: string): string {
      return d ? dayjs(d).format("YYYY.MM.DD.") : "";
    },

    formatNumber(v: number | null): string {
      return v == null ? "" : new Intl.NumberFormat("hu-HU", { maximumFractionDigits: 2 }).format(v);
    },

    // Napló-lenyíló felirata: rövid kód + megnevezés (csbokbooktype.nicname — .national).
    bookTypeText(bt: any): string {
      return bt.name ? `${bt.code} — ${bt.name}` : bt.code;
    },

    async loadYears() {
      this.years = await api.GetGeneralLedgerYears();
      // K2D il_Year alapértéke a globális aktív év — itt: a mai naptári évhez tartozó, különben a legfrissebb.
      const current = new Date().getFullYear();
      const match = this.years.find((y) => Number(y.year) === current);
      const sorted = [...this.years].sort((a, b) => Number(b.year) - Number(a.year));
      this.selectedYear = match ? Number(match.year) : sorted.length ? Number(sorted[0].year) : 0;
    },

    // A választott könyvelési évhez tartozó aktív fkszámok + dimenzió-kódok a lookupokhoz.
    async loadYearData() {
      if (!this.selectedYear) {
        this.accounts = [];
        this.dimensions = [];
        return;
      }
      const [accounts, dimensions] = await Promise.all([
        api.GetInvoiceMirrorsByYear(this.selectedYear),
        api.GetDimensionCodesByYear(this.selectedYear),
      ]);
      this.accounts = accounts;
      this.dimensions = dimensions;
    },

    // Dimenzió-kódok (mmbokdimcode) az adott típushoz: 2=dim1, 3=dim2, 4=dim3, 6=dim5.
    dimCodesFor(type: number): any[] {
      return this.dimensions.filter((d) => d.type === type);
    },

    // A LookupComboBox a kiválasztott sort adja; a staging a KÓDOT tárolja (a szam-ra feloldást a SP végzi).
    onAccountChange(row: TransactionImportRow, selected: any) {
      row.accNo = selected && selected.accno ? selected.accno : "";
      this.dirty = true;
    },

    onDimCodeChange(row: TransactionImportRow, field: string, selected: any) {
      (row as any)[field] = selected && selected.dimcode ? selected.dimcode : null;
      this.dirty = true;
    },

    onWorkNumberChange(row: TransactionImportRow, selected: any) {
      row.workNumber = selected && selected.workNumber ? selected.workNumber : null;
      this.dirty = true;
    },

    // A staging DB-tartalma (base). Eldobja a puffert és a nem mentett állapotot.
    async reload() {
      eventBus.$emit("busy-message", true);
      try {
        const list = await api.GetTransactionImportRows();
        // UI-flagek kezdőértékkel, hogy reaktívak legyenek (Vue 2).
        this.rows = list.map((r) => ({ ...r, selected: false, deleting: false, hasError: false, inEdit: false }));
        this.editingRow = null;
        this.dirty = false;
        this.clearConfirm = false;
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },

    async uploadFile() {
      if (!this.file) return;
      this.uploadErrors = [];
      this.bookErrors = [];
      this.createdIds = [];
      eventBus.$emit("busy-message", true);
      try {
        const result = await api.UploadTransactionImportFile(this.file);
        if (!result.success) {
          this.uploadErrors = result.errors.length > 0 ? result.errors : [result.message];
          eventBus.$emit("error", result.message);
          return;
        }
        // A beparse-olt sorok a kliens-pufferbe (egyedi ideiglenes id-val); DB-be még nem íródtak.
        this.rows = result.rows.map((r) => ({
          ...r,
          id: this.nextTempId--,
          selected: false,
          deleting: false,
          hasError: false,
          inEdit: false,
        }));
        this.editingRow = null;
        this.dirty = true;
        this.file = null;
        eventBus.$emit("success", result.message);
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", t("GeneralLedger_AFajlBetolteseNemSikerult"));
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },

    // A kliens-puffer teljes tartalmának kiírása a stagingbe (K2D pb_ok). A könyvelésre kijelölést
    // külső-ID szerint visszaállítjuk az újratöltés után, hogy a Könyvelés utána is működjön.
    async save(): Promise<boolean> {
      this.uploadErrors = [];
      const selectedIds = new Set(this.rows.filter((r) => r.selected).map((r) => r.externalTrId));
      eventBus.$emit("busy-message", true);
      try {
        const result = await api.SaveTransactionImportRows({ rows: this.rows });
        if (!result.success) {
          this.uploadErrors = result.errors.length > 0 ? result.errors : [result.message];
          eventBus.$emit("error", result.message);
          return false;
        }
        eventBus.$emit("success", result.message);
        await this.reload();
        this.rows.forEach((r) => (r.selected = selectedIds.has(r.externalTrId)));
        return true;
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", t("GeneralLedger_AMentesNemSikerult"));
        return false;
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },

    async cancelChanges() {
      this.uploadErrors = [];
      this.bookErrors = [];
      await this.reload();
      // eventBus.$emit("success", "A módosítások elvetve, a mentett állapot visszaállítva.");
    },

    addRow() {
      const today = dayjs().format("YYYY-MM-DD");
      const row: TransactionImportRow = {
        id: this.nextTempId--,
        selected: false,
        deleting: false,
        hasError: false,
        inEdit: false,
        accEvent: "",
        externalTrId: "",
        remark: null,
        extCode: null,
        accNo: "",
        accDate: today,
        accSign: "T",
        total: 0,
        currency: "HUF",
        currTotal: 0,
        exchangeRate: 1,
        note: null,
        bookTypeCode: "MX",
        dimCode1: null,
        dimCode2: null,
        dimCode3: null,
        dimCode11: null,
        dimCode9: null,
        car: 1,
        workNumber: null,
        rateDate: null,
        invNo: 1,
        insDate: today,
        userId: 0,
      };
      this.rows.push(row);
      this.editingRow = row;
      this.dirty = true;
    },

    onRowClick(event: any) {
      this.editingRow = event.dataItem;
    },

    onDateInput(row: TransactionImportRow, value: string) {
      row.accDate = value;
    },

    markDirty() {
      this.dirty = true;
    },

    // Az érvényes árfolyam: HUF-nál MINDIG 1 (K2D ue_deviza) — egy korábbi deviza-szerkesztésből
    // visszamaradt, még tárolt pozitív exchangeRate-et is felülír, egyébként a beírt árfolyam.
    rateOf(row: TransactionImportRow): number {
      if ((row.currency || "HUF").toUpperCase() === "HUF") return 1;
      return Number(row.exchangeRate) || 0;
    },

    // Deviza / árfolyam változott: a deviza összeg marad, a HUF total számítódik újra (K2D ue_deviza).
    // HUF-ra váltáskor a MEZŐN megjelenő árfolyamot is 1-re állítjuk, hogy a kijelzés ne mutasson
    // egy korábbi (deviza módú) szerkesztésből visszamaradt, a számításban már figyelmen kívül
    // hagyott értéket.
    onAmount(row: TransactionImportRow) {
      if ((row.currency || "HUF").toUpperCase() === "HUF") row.exchangeRate = 1;
      const rate = this.rateOf(row);
      row.total = Math.round((Number(row.currTotal) || 0) * rate * 100) / 100;
      this.totalTemp = row.total;
      this.currTotalTemp = Number(row.currTotal) || 0;
      this.dirty = true;
    },

    // HUF összeg beírva → a deviza összeg számítódik újra (total / árfolyam), és fordítva.
    onTotalChange(row: TransactionImportRow) {
      row.total = this.totalTemp;
      const rate = this.rateOf(row);
      const currTotal = rate > 0 ? Math.round((this.totalTemp / rate) * 100) / 100 : this.totalTemp;
      row.currTotal = currTotal;
      this.currTotalTemp = currTotal;
      this.dirty = true;
    },

    onCurrTotalChange(row: TransactionImportRow) {
      row.currTotal = this.currTotalTemp;
      const total = Math.round(this.currTotalTemp * this.rateOf(row) * 100) / 100;
      row.total = total;
      this.totalTemp = total;
      this.dirty = true;
    },

    async runCheck() {
      await this.runBook(true);
    },

    async book() {
      await this.runBook(false);
    },

    async runBook(checkOnly: boolean) {
      this.bookErrors = [];
      this.createdIds = [];
      // K2D pb_check/pb_ok: az ellenőrzés/könyvelés is a hmboktmptrans-ból dolgozik, ezért előbb
      // mentünk — így mindkét gomb a JELENLEGI (szerkesztett) adatot validálja/könyveli.
      if (this.dirty) {
        const saved = await this.save();
        if (!saved) return;
      }
      eventBus.$emit("busy-message", true);
      try {
        const result = await api.BookTransactionImport({
          rowIds: this.rows.filter((r) => r.selected).map((r) => r.id),
          status: this.status,
          transType: this.transType,
          bookType: this.bookType, // K2D dw_status napló — az üres naplójú sorok SP-fallbackje
          checkOnly,
        });
        this.applyErrors(result.errors);
        if (!result.success) {
          eventBus.$emit("error", result.message);
          return;
        }
        if (checkOnly && result.errors.length > 0) {
          eventBus.$emit("warn", result.message);
        } else {
          eventBus.$emit("success", result.message);
        }
        if (!checkOnly) {
          this.createdIds = result.createdTransactionIds;
          await this.reload();
          // A megmaradt (nem könyvelt) sorok hibajelzését visszatesszük.
          this.applyErrors(result.errors);
        }
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", checkOnly ? t("GeneralLedger_AzEllenorzesNemSikerult") : t("GeneralLedger_AKonyvelesNemSikerult"));
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },

    applyErrors(errors: TransactionImportError[]) {
      this.bookErrors = errors;
      const errorRowIds = new Set(errors.map((e) => e.rowId));
      this.rows.forEach((r) => (r.hasError = errorRowIds.has(r.id)));
    },

    // A sorhoz tartozó konkrét mezőhibák (a piros háromszög tooltipjéhez).
    rowErrors(row: TransactionImportRow): string[] {
      const msgs = this.bookErrors.filter((e) => e.rowId === row.id).map((e) => e.message);
      return msgs.length > 0 ? msgs : [t("GeneralLedger_AzEllenorzesHibatTalaltASorban")];
    },

    // K2D pb_treff: a kijelölés a teljes külső-ID-csoportra kerül fel/le.
    toggleGroup(row: TransactionImportRow) {
      const target = !row.selected;
      this.rows
        .filter((r) => r.externalTrId === row.externalTrId)
        .forEach((r) => (r.selected = target));
    },

    selectAll(selected: boolean) {
      this.rows.forEach((r) => (r.selected = selected));
    },

    askDelete(row: TransactionImportRow) {
      const reopen = !!row.deleting;
      this.rows.forEach((r) => (r.deleting = false));
      if (!reopen) row.deleting = true;
    },

    // Puffer-törlés: csak a gridből távolítja el; a DB-be a Mentéssel véglegesül.
    confirmDelete(row: TransactionImportRow) {
      row.deleting = false;
      const i = this.rows.indexOf(row);
      if (i >= 0) this.rows.splice(i, 1);
      if (this.editingRow === row) this.editingRow = null;
      this.dirty = true;
    },

    cancelDelete(row: TransactionImportRow) {
      row.deleting = false;
    },

    // Betöltött sorok törlése: a megerősítés AZONNAL töröl a DB-ből is (üres puffer mentése =
    // a staging teljes ürítése), nem kell utána külön Mentés — különben elfelejtenék megnyomni.
    async clearAll() {
      this.clearConfirm = false;
      eventBus.$emit("busy-message", true);
      try {
        const result = await api.SaveTransactionImportRows({ rows: [] });
        if (!result.success) {
          this.uploadErrors = result.errors.length > 0 ? result.errors : [result.message];
          eventBus.$emit("error", result.message);
          return;
        }
        this.rows = [];
        this.editingRow = null;
        this.bookErrors = [];
        this.uploadErrors = [];
        this.dirty = false;
        eventBus.$emit("success", t("GeneralLedger_ABetoltottSorokTorolve"));
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", t("ATorlesNemSikerult"));
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },

    async downloadTemplate() {
      try {
        const base64 = await api.GetTransactionImportTemplate();
        const link = document.createElement("a");
        link.href = `data:application/vnd.openxmlformats;base64,${base64}`;
        link.download = "tranzakcio_import_sablon.xlsx";
        link.click();
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", t("GeneralLedger_ASablonLetolteseNemSikerult"));
      }
    },
  },

  watch: {
    // A szerkesztett sor váltásakor a formázott összeg-inputok temp-változóit feltöltjük (TransactionItemEdit minta).
    editingRow(row: TransactionImportRow | null) {
      this.totalTemp = row ? Number(row.total) || 0 : 0;
      this.currTotalTemp = row ? Number(row.currTotal) || 0 : 0;
    },
  },
});
